import React from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from '@material-ui/icons/Help';

export const AddIcon = (props) => {
  const addButtonClick = (helptext) => {
    alert(helptext)
  };
  return (
      <IconButton onClick={() => addButtonClick(props.helptext)}>
        <InputAdornment position="start" >{props.unit}</InputAdornment>
        <HelpIcon />
      </IconButton>
  );
};